import { createApp } from 'vue'
import type { App as VueApp } from 'vue';

import App from './App.vue'
import pinia from '@/plugins/pinia.ts';
import router from '@/router/index.ts';
import vuetify from '@/plugins/vuetify/config.ts';
import i18n from '@/plugins/i18n/config.ts'

import './assets/style.css'

import initializeSentry from '@/plugins/sentry.ts';
import initializeInterceptor from '@/services/utils/interceptor.ts'

const app: VueApp<Element> = createApp(App)

app.use(pinia)
app.use(router)
app.use(vuetify)
app.use(i18n)

initializeSentry(app, router)
initializeInterceptor()

app.mount('#app')
